// @flow
import { Cookies } from "react-cookie";

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
  const token = getAuthToken();

  if (!token?.access && !token?.refresh) {
    setToken(null);

    return false;
  }

  return true;
};

/**
 * Returns the logged in user
 */
const getAuthToken = () => {
  const cookies = new Cookies();
  const token = cookies.get("token");

  return token;
};

const setToken = (token) => {
  let cookies = new Cookies();
  if (token) cookies.set("token", JSON.stringify(token), { path: "/" });
  else cookies.remove("token", { path: "/" });
};

export { isUserAuthenticated, getAuthToken, setToken };
